import { createSlice } from "@reduxjs/toolkit";
import { Special } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { showAlert } from "./alerts.js";
import { createAppAsyncThunk } from "./utils.js";

const sliceName = "specials";

const initialState: Special[] = [];

export const getSpecials = createAppAsyncThunk(
  `${sliceName}/getSpecials`,
  async (siteId: string, { dispatch }) => {
    try {
      const { data } = await fetch({
        dispatch,
        languageId: "de",
        authorize: false,
      }).get<Special[]>(`sites/${siteId}/specials`);
      return data;
    } catch (error) {
      dispatch(
        showAlert("Beim Laden der Special-Daten ist ein Fehler aufgetreten!"),
      );
      throw error;
    }
  },
  {
    condition: (_siteId, { getState }) => {
      const loadState = getState().loadStates.specials;
      return loadState === "unloaded" || loadState === undefined;
    },
  },
);

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSpecials.fulfilled, (_state, action) => action.payload);
  },
});

export default slice.reducer;
